<template>
  <div>
   <div class="box column is-10" style="background-color: hsl(229, 53%, 96%); padding: 12px" v-if="modo === 'firmar' && $store.getters.hasAnyRole(['empleado'])">
      <h1 class="title is-4 is-flex is-justify-content-space-between is-align-items-center" style="margin-bottom: 12px;">
        <span>Opciones para empleado</span>
      </h1>
      <div class="columns is-vcentered">
        <div class="column is-narrow">
          <h3 class="subtitle is-6 column-is-2">Seleccione el firmador a utilizar:</h3>
        </div>
        <div class="column is-5">
          <div class="dropdown is-fullwidth" :class="{ 'is-active': isOpen }">
            <div class="dropdown-trigger"  style="width: 100%">
              <button class="button is-fullwidth is-flex is-justify-content-flex-start" @click="toggleDropdown">
                <span>{{ firmadorSelected ? firmadorSelected.titulo : 'Elegí una opción' }}</span>
                <span class="icon is-small ml-auto">
                  <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div class="dropdown-menu">
              <div class="dropdown-content">
                <a v-for="(option) in firmadoresDisponibles.filter(option => option.visible)" :key="option.id"
                  class="dropdown-item"
                  :class="{'is-disabled': option.disabled}"
                  @click="!option.disabled && selectOption(option)">
                    <div>
                      <i :class="option.icono"></i>
                      <strong>{{ option.titulo }}</strong>
                    </div>
                    <div class="has-text-grey is-size-7">{{ option.subTitulo }}</div>
                    <hr class="dropdown-divider" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
            <button @click="confirmFirmar()" class="button is-primary is-fullwidth"
            :disabled="!firmadorHabilitado()">
              <i class="fas fa-upload fa-fw"></i>&nbsp;Firmar Recibos</button>
        </div>
      </div>
    </div>
    <div class="box">
      <h2 class="title is-4">Recibos Pendientes de firma</h2>
      <b-table
        :class="recibosPend.length > 0 ? 'cursor-pointer' : 'cursor-default'"
        :data="recibosPend"
        :bordered="false"
        :narrowed="false"
        :hoverable="true"
        :loading="isLoading"
        :mobile-cards="true"
        :sortable="true"
        @dblclick="goToDocument"
        @check="checkRow">

        <b-table-column field="nombre" label="Recibo" sortable v-slot="props">
          <span class="break-word"><i class="fas fa-dollar-sign"></i>&nbsp;&nbsp;{{ props.row.nombre }}</span>
        </b-table-column>

        <b-table-column field="empleado.usuario.apellido" sortable label="Empleado" v-slot="props" v-if="$store.getters.hasAnyRole(['lyris', 'empleador'])">
          {{ props.row.empleado.usuario.apellido }}, {{ props.row.empleado.usuario.nombre }}
        </b-table-column>
<!--         <b-table-column field="estado" label="Conformidad2" sortable centered v-slot="props"  v-if="firmadorSelected?.valorClave != 'signar_v3'">
          <span><i class="fas" :class="`${getConformidadIcon(props.row.estado)}`"></i></span>
        </b-table-column>
        <b-table-column field="estadoConformidad" label="Conformidad3" centered
          style="padding: 4px;" v-slot="props"
          v-if="$store.getters.hasAnyRole(['empleado']) && firmadorSelected?.valorClave === 'signar_v3'">
          <div style="display: flex; align-items: center ; gap: 8px;">
            <i class="fas" :class="`${getConformidadIconSelect(props.row.estadoConformidad)} ${getConformidadIconSelect(props.row.estadoConformidad)}`"></i>
            <b-select
              v-model="props.row.estadoConformidad"
              placeholder="Seleccionar"
              size="is-small"
              :class="{
                'select-verde': props.row.estadoConformidad === 'En Conformidad',
                'select-rojo': props.row.estadoConformidad === 'En Disconformidad'
              }"
              >
              <option value="En Conformidad">En Conformidad</option>
              <option value="En Disconformidad">En Disconformidad</option>
            </b-select>
            </div>
          </b-table-column> -->
          <!-- <template v-if="firmadorSelected?.valorClave !== 'signar_v3'"></template> -->
        <template v-if="!esSignarV3">
          <b-table-column field="estado" label="Conformidad" sortable centered v-slot="props">
            <span>
              <i class="fas" :class="getConformidadIcon(props.row.estado)"></i>
            </span>
          </b-table-column>
        </template>
          <template v-if="$store.getters.hasAnyRole(['empleado']) && esSignarV3">
          <b-table-column
            field="estadoConformidad"
            label="Conformidad"
            centered
            style="padding: 4px;"
            v-slot="props"
          >
            <div style="display: flex; align-items: center; gap: 8px;">
              <i
                class="fas"
                :class="getConformidadIconSelect(props.row.estadoConformidad)"
              ></i>

              <b-select
                v-model="props.row.estadoConformidad"
                placeholder="Seleccionar"
                size="is-small"
                :class="{
                  'select-verde': props.row.estadoConformidad === 'En Conformidad',
                  'select-rojo': props.row.estadoConformidad === 'En Disconformidad'
                }"
              >
                <option value="En Conformidad">En Conformidad</option>
                <option value="En Disconformidad">En Disconformidad</option>
              </b-select>
            </div>
          </b-table-column>
        </template>
      <!--    <b-table-column field="estado" label="Conformidad" sortable centered v-slot="props">
            <span><i class="fas" :class="`${getConformidadIcon(props.row.estado)} ${getConformidadIcon(props.row.estado)}`"></i></span>
          </b-table-column>
  -->
        <b-table-column field="fecha" label="Fecha" sortable centered v-slot="props">
          {{ new Date(props.row.fecha) | moment('DD/MM/YYYY') }}
        </b-table-column>

        <b-table-column label="Tipo" centered v-slot="props">
          {{ props.row.tipo_recibo.nombre }}
        </b-table-column>

        <template #empty>
          <div class="is-family-monospace has-text-centered"><span v-if="isLoading"></span><span v-else>No hay recibos que cumplan con los filtros de busqueda</span></div>
        </template>
      </b-table>
      <infinite-loading @infinite="infiniteHandlerDocuments" :identifier="identifierLoaderDocuments">
        <div slot="no-more" class=" py-5 is-size-7 is-family-monospace"><span v-if="isLoading">Cargando...</span><span v-else>~ Fin del listado ~</span></div>
        <div slot="no-results" class=" py-5 is-size-7 is-family-monospace"><span v-if="isLoading">Cargando...</span><span v-else>~ Fin del listado ~</span></div>
      </infinite-loading>
    </div>
  </div>
</template>
<script>
// import Paginator from '@/components/utils/Paginator.vue'
// import LoadingSpin from '@/components/utils/LoadingSpin.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  props: {
    modo: {
      type: String,
      required: true,
      default: 'firmar' // 'ver' es la otra opcion
    }
  },
  data () {
    return {
      isLoading: true,
      firmadoresDisponibles: null,
      firmadorSelected: null, // es un objeto con id, titulo, etc
      isOpen: false,
      recibosPend: [], // ver si sirve
      selectedArray: [], // ver o adaptar para que sirva
      identifierLoaderDocuments: Math.random(),
      queryDocuments: {
        estado: 'pendiente',
        tipo: null,
        fecha: null,
        organizacionId: null,
        empleado: null,
        page: 1
      }
    }
  },
  created: function () {
    this.firmadoresDisponibles = this.llenarOpcionesFirmadores()
    const disponibles = this.firmadoresDisponibles.filter(op => op.visible && !op.disabled)
    this.firmadorSelected = disponibles[0] || null
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser
    },
    esSignarV3 () {
      return !!this.firmadorSelected && this.firmadorSelected.valorClave === 'signar_v3'
    },
    url () {
      return '/recibo'
    }
  },
  components: {
    InfiniteLoading
    // Paginator,
    // LoadingSpin
  },
  methods: {
    firmadorHabilitado () {
      if (!this.firmadorSelected || !this.recibosPend) return false
      if (this.recibosPend?.length === 0) return false
      if (this.esSignarV3) {
        // que haya marcados todos (en conf o disconf, no importa)
        return (this.recibosPend.filter(x => (x.estadoConformidad)).length === this.recibosPend.length)
      }
      return true // caso pfdrar
    },
    infiniteHandlerDocuments ($state) {
      this.isLoading = true
      if (this.$props.modo === 'firmar') {
        this.queryDocuments.empleado = this.$store.getters.getUser.id
      } else {
        this.queryDocuments.empleado = null
      }
      this.$http.get(this.url, { params: this.queryDocuments })
        .then(({ data }) => {
          this.isLoading = false
          if (data.current_page === data.last_page) {
            this.recibosPend.push(...data.data)
            this.recibosPend = this.recibosPend.map(recibo => ({
              ...recibo,
              estadoConformidad: recibo.estadoConformidad || 'En Conformidad' // valor por defecto
            }))
            $state.complete()
          }
          if (data.current_page < data.last_page) {
            this.queryDocuments.page += 1
            this.recibosPend.push(...data.data)
            this.recibosPend = this.recibosPend.map(recibo => ({
              ...recibo,
              estadoConformidad: recibo.estadoConformidad || 'En Conformidad' // valor por defecto
            }))
            $state.loaded()
          }
        })
    },
    setQuery (query) {
      this.queryDocuments.estado = 'pendiente'
      this.queryDocuments.tipo = query.tipo
      this.queryDocuments.fecha = query.fecha
      this.queryDocuments.organizacionId = query.organizacionId
      this.queryDocuments.empleado = query.empleado
      this.queryDocuments.page = 1
      this.recibosPend = []
      this.identifierLoaderDocuments = Math.random()
    },
    refresh () {
      this.queryDocuments.page = 1
      this.recibosPend = []
      this.identifierLoaderDocuments = Math.random()
    },
    // updateResource (data) {
    //   this.selected = null
    //   // const anchor = data.find(e => e.nombre === '.')
    //   this.recibos = data
    // },
    goToDocument (documento) {
      console.log(documento)
      this.$router.push('/recibo/' + documento.id)
    },
    checkRow: function (checkedDocsArray) {
      this.$store.commit('recibos/setSelected', checkedDocsArray)
    },
    getConformidadIcon: function (status) {
      let icon = ''
      switch (status.toLowerCase()) {
        case 'pendiente':
          icon = 'fa-clock fa-fw has-text-warning'
          break
        case 'conformidad':
        case 'disponible':
          icon = 'fa-check fa-fw has-text-success'
          break
        case 'disconformidad':
          icon = 'fa-times fa-fw has-text-danger'
          break
        default:
          icon = 'fa-question fa-fw'
          break
      }
      return icon
    },
    getConformidadIconSelect: function (estadoConf) {
      switch (estadoConf) {
        case 'En Conformidad':
          return this.getConformidadIcon('conformidad')
        case 'En Disconformidad':
          return this.getConformidadIcon('disconformidad')
        default:
          return 'fa-question fa-fw'
      }
    },
    llenarOpcionesFirmadores () {
      const opcionesTmp = [
        {
          id: 1,
          valorClave: 'signar',
          icono: 'fas fa-upload fa-fw',
          titulo: 'Firmador Desktop Signar® v1',
          subTitulo: 'Firmador Desktop Signar',
          visible: (this.user && this.user.firmadores_habilitados.signar),
          disabled: false
        },
        {
          id: 2,
          valorClave: 'signar_v3',
          icono: 'fas fa-upload fa-fw',
          titulo: 'Firmador Integrable v3',
          subTitulo: 'Firmador Integrable Signar v.3',
          visible: (this.user && this.user.firmadores_habilitados.signar),
          disabled: false
        },
        {
          id: 3,
          valorClave: 'pfdrar',
          icono: 'fas fa-upload fa-fw',
          titulo: 'Plataforma de Firma Digital Remota',
          subTitulo: '(No Disponible) Secretaria de Modernización - Argentina',
          visible: (this.user && this.user.firmadores_habilitados.pfdrar),
          disabled: true
        }
      ]
      return opcionesTmp
    },
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },
    selectOption (optionFirmador) {
      this.firmadorSelected = optionFirmador
      this.isOpen = false
    },
    confirmFirmar () {
      this.$buefy.dialog.confirm({
        title: 'Firmar recibos',
        message: 'Usted va a firmar todos sus recibos pendientes en una única operación, desea continuar?',
        confirmText: 'Aceptar',
        cancelText: 'Cancelar',
        type: 'is-info',
        hasIcon: true,
        onConfirm: () => this.goFirmar()
      })
    },
    goFirmar () {
      if (!this.firmadorSelected) return
      switch (this.firmadorSelected.valorClave) {
        case 'signar':
          this.$emit('firmar-pendientes', 'signar', '')
          break
        case 'signar_v3':
          this.$emit('firmar-pendientes', 'signar_v3',
            this.recibosPend.map(item => item.id),
            this.recibosPend.map(item => item.estadoConformidad === 'En Conformidad' ? 'C' : 'D'))
          break
        case 'pfdrar':
          this.$emit('firmar-pendientes', 'pfdrar', '') // ojo qu eno se que debería hacer
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
table.table {
  tbody td {
    border: 0;
  }
}
.box {
  padding: 12px;
  margin-bottom: 12px;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.tag {
  cursor: pointer;
}
.is-disabled {
  color: #b5b5b5 !important;
  pointer-events: none;
  cursor: not-allowed;
  background-color: #f5f5f5;
}
.select-verde .select select:focus {
  background-color: #d4edda !important;
  border-color: #28a745 !important;
}
.select-rojo .select select:focus {
  background-color: #f8d7da !important;
  border-color: #dc3545 !important;
}
</style>
